import { render, staticRenderFns } from "./DanhSachNguoiDungTheoVaiTro.vue?vue&type=template&id=10163408&"
import script from "./DanhSachNguoiDungTheoVaiTro.vue?vue&type=script&lang=js&"
export * from "./DanhSachNguoiDungTheoVaiTro.vue?vue&type=script&lang=js&"
import style0 from "./DanhSachNguoiDungTheoVaiTro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports